import React from 'react'
import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue, useResetRecoilState } from 'recoil'

import {
  Modal,
  ModalHead,
  ModalBody,
  ModalFoot,
  Flex,
  Text,
  Button,
  BUTTON_VARIANT_PRIMARY,
  Link,
  LINK_VARIANT_EXTRALIGHT
} from 'mailup-web-components'

import { modalCreateTextVersionState } from '../recoil/state/modals'
import { createPlainTextCallback } from '../recoil/callbacks/callbacks'

const ModalCreateTextVersion = () => {
  const intl = useIntl()

  const { show } = useRecoilValue(modalCreateTextVersionState)
  const resetModal = useResetRecoilState(modalCreateTextVersionState)
  const createPlainText = useRecoilCallback(createPlainTextCallback, [])

  const handleConfirm = () => {
    resetModal()
    createPlainText()
  }

  return (
    <Modal
      show={show}
      showClose
      closeOnOverlayClick
      onClose={resetModal}
      data-mu-test='modal__create-text-version'
    >
      <ModalHead
        title={intl.formatMessage({
          id: 'Load.EmailCheckUp.PlainTextVersionGenerateModalTitle'
        })}
      />

      <ModalBody>
        <Text>
          {intl.formatMessage({
            id: 'Load.EmailCheckUp.PlainTextVersionGenerateModalBody'
          })}
        </Text>
      </ModalBody>
      <ModalFoot>
        <Flex alignItems='center' justifyContent='flex-end' gap='24px'>
          <Link
            variant={LINK_VARIANT_EXTRALIGHT}
            onClick={resetModal}
            data-mu-test='modal-create-text-version__cancel'
          >
            {intl.formatMessage({ id: 'Load.MailupCommon.Cancel' })}
          </Link>
          <Button
            kind={BUTTON_VARIANT_PRIMARY}
            onClick={handleConfirm}
            data-mu-test='modal-create-text-version__confirm'
          >
            {intl.formatMessage({
              id: 'Load.EmailCheckUp.PlainTextVersionGenerateModalCta'
            })}
          </Button>
        </Flex>
      </ModalFoot>
    </Modal>
  )
}

export default ModalCreateTextVersion
